<template>
  <div
    class="ml-auto flex h-6 items-center justify-center gap-1 rounded-full bg-agentnoon-board-pill px-2 text-sm font-medium text-agentnoon-board-pill bg-blend-multiply"
  >
    <span class="h-1 w-1 rounded-full bg-agentnoon-board-pill-bullet"></span>
    Main
  </div>
</template>
